import React from "react";

const Deduction = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M27.04 25.75c-.58 0-1.142.12-1.658.346l-1.699-1.699-3.977 3.978 4.397 4.397.02.02A4.097 4.097 0 0027.038 34a4.097 4.097 0 002.917-1.208 4.13 4.13 0 000-5.834 4.097 4.097 0 00-2.917-1.208zm1.59 5.716c-.425.425-.99.659-1.59.659a2.235 2.235 0 01-1.591-.66 2.253 2.253 0 010-3.181c.424-.425.99-.66 1.59-.66a2.253 2.253 0 011.59 3.841zM27.539 18.491a5.073 5.073 0 001.666-3.663 5.073 5.073 0 00-1.498-3.736l-.663-.663-15.667 15.667a4.114 4.114 0 00-1.657-.346 4.098 4.098 0 00-2.917 1.208 4.13 4.13 0 000 5.834A4.097 4.097 0 009.72 34a4.096 4.096 0 002.9-1.193l8-8 6.919-6.316zM11.311 31.466c-.425.425-.99.659-1.591.659s-1.166-.234-1.591-.659a2.252 2.252 0 011.59-3.841c.602 0 1.167.234 1.592.659a2.253 2.253 0 010 3.182zM18.375 24a.937.937 0 110-1.875.937.937 0 010 1.875zM30.938 2H5.813A2.816 2.816 0 003 4.813V7h30.75V4.813A2.816 2.816 0 0030.938 2zM13.072 21.75L25.947 8.875H3v10.063a2.816 2.816 0 002.813 2.812h7.259z"
              fill={fill}
        />
        <path className="u_fill"
              d="M28.37 9.104l.663.663a6.933 6.933 0 012.046 5.104 6.933 6.933 0 01-2.276 5.005l-2.052 1.874h4.187a2.816 2.816 0 002.812-2.812V8.875h-5.609l.229.229z"
              fill={fill}
        />
    </svg>
);

export default Deduction;
